module.exports = __webpack_public_path__ + "static/banner-engineering-a40c1798c591eb6d256392e24e1ddc07.png";